import Presentation from './presentation.jsx'
import { withPresentation, usePresentation } from './presentation-connectors'
import { usePresentationNavigation } from './presentation-hooks'
import {
  accessibilityColors,
  accessibilityColorsList,
  backgroundColors,
  backgroundColorsList
} from './colors'
import { sanitizeHtml } from './utils'
import { PresentationThumbnail } from './presentation-thumbnail'

const CATEGORIES = {
  image: 'Image',
  video: 'Video',
  works: 'Work',
  word_bank: 'Word Bank',
  success_criteria: 'Success Criteria',
  pobble365: 'Pobble 365',
  pobble365_plus: 'Pobble 365 +',
  news: 'Pobble News',
  theme_based: 'Theme-based',
  objective: 'Objective',
  quick_writes: 'Quick Writes',
  lesson_starters: 'Lesson Starters',
  literacy_through_sport: 'Literacy Through Sport',
  printables: 'Printables'
}

export {
  Presentation,
  PresentationThumbnail,
  withPresentation,
  usePresentation,
  usePresentationNavigation,
  accessibilityColors,
  accessibilityColorsList,
  backgroundColors,
  backgroundColorsList,
  sanitizeHtml,
  CATEGORIES
}
